import styled from "styled-components";
import SpeedDial from "@mui/material/SpeedDial";
import { Link } from "react-router-dom";
import { theme } from "styles/mui-config";
import { Button } from "@mui/material";

export const StyledSpeedDial = styled(SpeedDial)`
  bottom: 20px;
  @media (max-width: 899.9px) {
    bottom: 70px !important;
  }
`;

export const StyledButton = styled(Button)`
  width: 56px !important;
  min-width: auto !important;
  height: 56px !important;
  z-index: 1050;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  color: #fff !important;
  background-color: ${theme.palette.primary.dark} !important;
  border-radius: 50% !important;
  position: fixed !important;
  bottom: 20px;
  right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  & > span > span {
    top: -5px;
    right: 36px;
    background: white;
    border: 1.5px solid ${theme.palette.primary.dark};
    background: white;
    color: ${theme.palette.primary.dark};
  }
  & > span > svg {
    color: white !important;
  }
  :hover {
    background-color: ${theme.palette.primary.dark};
  }
  :active {
    box-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2),
      0px 12px 17px 2px rgba(0, 0, 0, 0.14),
      0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  }
  @media (max-width: 1000px) {
    margin-bottom: 60px !important;
  }
`;

export const StyledLinkcart = styled(Link)`
  width: 56px;
  height: 56px;
  z-index: 1050;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  color: #fff;
  background-color: ${theme.palette.primary.dark};
  border-radius: 50%;
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  & > span > span {
    top: -5px;
    right: 36px;
    background: white;
    border: 1.5px solid ${theme.palette.primary.dark};
    background: white;
    color: ${theme.palette.primary.dark};
  }
  & > span > svg {
    color: white;
  }
  :hover {
    background-color: ${theme.palette.primary.dark};
  }
  :active {
    box-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2),
      0px 12px 17px 2px rgba(0, 0, 0, 0.14),
      0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  }
  @media (max-width: 1000px) {
    margin-bottom: 60px !important;
  }
`;
